import React from "react";
import useTranslation from "next-translate/useTranslation";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { Accordion } from "@/components/Accordion";
import Trans from "next-translate/Trans";

export const EnterpriseSolutionsFaqSection: React.FC = () => {
  const { bp, colors } = useTheme();
  const { css } = useFela();
  const { t } = useTranslation("section/enterpriseSolutionsFaq");

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "56px 20px 36px",
        },
      }}
      id="EnterpriseSolutionsFaqSection"
    >
      <Heading
        as="h2"
        customStyle={{ color: colors.CHARCOAL, textAlign: "center" }}
      >
        {t("title")}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          [bp.FROM_TABLET]: {
            flexDirection: "row",
          },
        })}
      >
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
              marginRight: 21,
            },
          })}
        >
          <Accordion
            title={t("security.question")}
            longAnswer={t("security.answer")}
          />
          <Accordion
            title={t("filesEncryption.question")}
            longAnswer={t("filesEncryption.answer")}
          />
          <Accordion
            title={t("payment.question")}
            longAnswer={t("payment.answer")}
          />
        </div>
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
            },
          })}
        >
          <Accordion
            title={t("plansDifference.question")}
            longAnswer={
              <Trans
                i18nKey="section/enterpriseSolutionsFaq:plansDifference.answer"
                components={[
                  <p key="0" className={css({ marginBottom: 16 })} />,
                  <p key="1" />,
                ]}
              />
            }
            customStyleContent={{ overflowY: "auto" }}
          />
          <Accordion
            title={t("vendorApproval.question")}
            longAnswer={t("vendorApproval.answer")}
          />
          <Accordion
            title={t("deleteFiles.question")}
            longAnswer={t("deleteFiles.answer")}
          />
        </div>
      </div>
    </Grid>
  );
};
